<template>
  <div class="mainDiv">
    <el-tabs
      v-model="reviewStatus"
      type="card"
      @tab-click="handleReviewStatusChange"
    >
      <el-tab-pane
        v-for="item in reviewStatusList"
        :key="item.value"
        :label="item.label"
        :name="item.value"
      ></el-tab-pane>
    </el-tabs>

    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row>
              <el-col :span="6">
                <el-form-item label="班级名称：">
                  <el-input
                    size="small"
                    v-model="form.albumTitle"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所属专业：">
                  <el-input
                    size="small"
                    v-model="form.majorName"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="reviewStatus != '2'">
                <el-form-item label="报名方式：">
                  <el-select
                    v-model="form.applyType"
                    size="small"
                    clearable
                    placeholder="-不限-"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in applyTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="学校：">
                  <el-input
                    size="small"
                    v-model="form.schoolId"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="班级编码：">
                  <el-input
                    size="small"
                    v-model="form.classCode"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付状态：">
                  <el-select
                    v-model="form.payStatus"
                    size="small"
                    placeholder="-不限-"
                    clearable
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in payStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="reviewStatus != '2'">
                <el-form-item label="审核状态：">
                  <el-select
                    v-model="form.verifyStatus"
                    size="small"
                    clearable
                    placeholder="-不限-"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in approvalStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="订单金额：">
                  <el-input
                    size="small"
                    v-model="form.minPrice"
                    clearable
                  ></el-input>
                  <div style="padding: 0 10px">一</div>
                  <el-input
                    size="small"
                    v-model="form.maxPrice"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="姓名：">
                  <el-input
                    size="small"
                    v-model="form.zName"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机号：">
                  <el-input
                    size="small"
                    v-model="form.phone"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="订单ID：">
                  <el-input
                    size="small"
                    v-model="form.orderId"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="reviewStatus != '2'">
                <el-form-item label="审核人：">
                  <el-input
                    size="small"
                    v-model="form.checkName"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="报名时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.applyTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="timestamp"
                    :unlink-panels="true"
                    clearable
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="年度：">
                  <el-input
                    size="small"
                    v-model="form.year"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="学期：">
                  <el-input
                    size="small"
                    v-model="form.term"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search">
                  确定
                </el-button>
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll"> 清空 </el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">筛选</el-button>
        <el-button
          v-if="reviewStatus != 2"
          type="primary"
          @click="clickStatistics"
        >
          统计筛选结果
        </el-button>
        <el-button v-if="reviewStatus != 2" type="primary" @click="exportRegist"
          >导出筛选结果</el-button
        >
        <el-button
          v-if="reviewStatus == 2"
          type="primary"
          @click="showBatchReview"
          >批量审核</el-button
        >
      </div>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column width="50" label="序号">
        <template slot-scope="scope">{{
          scope.$index + 1 + (pageObj.page - 1) * pageObj.pageSize
        }}</template>
      </el-table-column>
      <el-table-column
        prop="orderId"
        label="订单ID"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="majorName"
        label="所属专业"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="albumTitle"
        label="班级名称"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        label="班级编码"
        align="center"
        header-align="center"
        prop="classCode"
      >
      </el-table-column>
      <el-table-column
        prop="term"
        label="学期"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.term == '1'">秋季学期</div>
          <div v-else-if="scope.row.term == '2'">春季学期</div>
          <div v-else-if="scope.row.term == '3'">夏季学期</div>
          <div v-else>{{ scope.row.term }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="year"
        label="年度"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="price"
        label="订单金额"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="zName"
        label="姓名"
        align="center"
        header-align="center"
      >
        <!-- <template slot-scope="scope">
          <div v-if="scope.row.term == '1'">秋季学期</div>
          <div v-if="scope.row.term == '2'">春季学期</div>
          <div v-if="scope.row.term == '3'">夏季学期</div>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机号（账号）"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="ctime"
        label="报名时间"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="verifyStatus"
        label="审核状态"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.verifyStatus == '0'">不通过</div>
          <div v-if="scope.row.verifyStatus == '1'">通过</div>
          <div v-if="scope.row.verifyStatus == '2'">待审核</div>
          <div v-if="scope.row.verifyStatus == '4'">审核退回</div>
          <div v-if="scope.row.verifyStatus == '5'">无需审核</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="payStatus"
        label="缴费状态"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.payStatus == '1'">未缴费</div>
          <div v-if="scope.row.payStatus == '2'">已取消</div>
          <div v-if="scope.row.payStatus == '3'">已缴费</div>
          <div v-if="scope.row.payStatus == '5'">已退款</div>
        </template></el-table-column
      >
      <el-table-column
        prop="checkTime"
        label="审核时间"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="noPassReason"
        label="审核意见"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="checkName"
        label="审核人"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="ptime"
        label="缴费时间"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="uname"
        label="操作"
        min-width="200"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div class="table_control">
            <span
              class="table_control_item"
              v-if="reviewStatus !== '2'"
              @click="checkRegistrationInfo(scope)"
              >查看报名信息</span
            >
            <span
              class="table_control_item"
              v-if="reviewStatus === '2'"
              @click="auditRegist(scope)"
            >
              审核报名信息</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="!isAddClass"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
    <ClassRegistInfo
      :params="operateParam"
      v-if="checkRegistInfo"
      @closeRegistInfo="closeRegistInfo"
    />
    <BatchReview
      v-if="isShowBatchReview"
      :selectedList="selectedList"
      @closeBatchReview="closeBatchReview"
    />
    <ClassRegistAudit
      v-if="isShowClassRegistAudit"
      :params="operateParam"
      @closeClassRegistAudit="closeClassRegistAudit"
    />
  </div>
</template>

<script>
import * as api from '@/api/ClassRegistManagement/index.js'
import ClassRegistInfo from './class-regist-info'
import BatchReview from './batch-review'
import ClassRegistAudit from './class-regist-audit'

export default {
  components: {
    ClassRegistInfo,
    BatchReview,
    ClassRegistAudit,
  },
  data() {
    return {
      reviewStatusList: [
        { value: '0', label: '报名列表' },
        { value: '2', label: '报名审核' },
        { value: '3', label: '历史报名列表' },
      ],
      reviewStatus: '0',
      activeNames: [],
      form: {
        albumTitle: '',
        majorName: '',
        applyType: '',
        schoolId: '',
        classCode: '',
        payStatus: '',
        verifyStatus: '',
        minPrice: '',
        maxPrice: '',
        zName: '',
        phone: '',
        orderId: '',
        checkName: '',
        year: '',
        term: '',
      },
      applyTime: '',
      approvalStatus: [
        {
          value: '2',
          label: '待审核',
        },
        {
          value: '1',
          label: '审核通过',
        },
        {
          value: '4',
          label: '审核退回',
        },
        {
          value: '0',
          label: '审核不通过',
        },
        {
          value: '5',
          label: '无需审核',
        },
      ],
      payStatus: [
        {
          value: '1',
          label: '未缴费',
        },
        {
          value: '2',
          label: '已缴费',
        },
        {
          value: '3',
          label: '已退款',
        },
        {
          value: '4',
          label: '无需退款',
        },
      ],
      applyTypeList: [
        {
          value: '1',
          label: '先审核后缴费',
        },
        {
          value: '2',
          label: '先缴费后审核',
        },
        {
          value: '3',
          label: '仅审核无缴费',
        },
        {
          value: '4',
          label: '无审核仅缴费',
        },
        {
          value: '5',
          label: '无审核无缴费',
        },
      ],
      termList: [
        {
          value: '1',
          label: '秋季学期',
        },
        {
          value: '2',
          label: '春季学期',
        },
        {
          value: '3',
          label: '夏季学期',
        },
      ],
      selectedList: [],
      tableData: [],
      isAddClass: false,
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      params: null,
      checkRegistInfo: false,
      operateParam: null,
      registDialogVisible: false,
      isShowBatchReview: false,
      isShowClassRegistAudit: false,
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  created() {
    this.initForm = { ...this.form }
    this.getApplyList()
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      const dateee = new Date(date).toJSON()
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    closeBatchReview() {
      this.isShowBatchReview = false
      this.getApplyList()
    },
    showBatchReview() {
      console.log(this.selectedList)
      if (this.selectedList.length < 1) {
        return this.$message.warning('至少选择一个')
      }
      this.isShowBatchReview = true
    },
    handleQueryParam() {
      let {
        albumTitle,
        majorName,
        applyType,
        schoolId,
        classCode,
        payStatus,
        verifyStatus,
        minPrice,
        maxPrice,
        zName,
        phone,
        orderId,
        checkName,
        year,
        term,
        applyTime,
      } = this.form
      console.log('this.form', this.form)
      let [minCtime, maxCtime] = applyTime || ['', '']
      const query = {
        albumTitle,
        majorName,
        applyType,
        schoolId,
        classCode,
        payStatus,
        verifyStatus,
        minPrice,
        maxPrice,
        zName,
        phone,
        orderId,
        checkName,
        year,
        term,
        minCtime: minCtime ? minCtime / 1000 : '',
        maxCtime: maxCtime ? maxCtime / 1000 : '',
      }
      return query
    },
    async getApplyList() {
      let query = this.handleQueryParam()
      const { code, data } = (
        await api.getApplyList({
          status: this.reviewStatus === '0' ? null : this.reviewStatus,
          ...query,
          uid: this.getUId,
          ...this.pageObj,
        })
      ).data
      if (code === 100000) {
        this.tableData = data.list.map((item) => {
          item.ctime = this.formatDate((item.ctime && item.ctime * 1000) || '')
          item.checkTime = this.formatDate(item.checkTime)
          item.ptime = this.formatDate(item.ptime)
          return { ...item }
        })
        this.total = data.total
      }
    },
    exportRegist() {
      let query = this.handleQueryParam()
      console.log(656, query)
      if (!query.minCtime || !query.maxCtime) {
        this.$message.warning('请选择报名开始时间与结束时间')
        return
      }
      window.open(
        `${this.url}/zkfz/userApprove/exportAlbumExcel?status=${
          this.reviewStatus === '0' ? '' : this.reviewStatus
        }&uid=${this.getUId}&albumTitle=${query.albumTitle}&majorName=${
          query.majorName
        }&applyType=${query.applyType}&schoolId=${query.schoolId}&classCode=${
          query.classCode
        }&payStatus=${query.payStatus}&verifyStatus=${
          query.verifyStatus
        }&minPrice=${query.minPrice}&maxPrice=${query.maxPrice}&zName=${
          query.zName
        }&phone=${query.phone}&orderId=${query.orderId}&checkName=${
          query.checkName
        }&year=${query.year}&term=${query.term}&minCtime=${
          query.minCtime
        }&maxCtime=${query.maxCtime}`
      )
    },
    clickStatistics() {
      let query = this.handleQueryParam()
      console.log(656, query)
      if (!query.minCtime || !query.maxCtime) {
        this.$message.warning('请选择报名开始时间与结束时间')
        return
      }
      window.open(
        `${this.url}/zkfz/userApprove/exportAlbumStatisticsExcel?status=${
          this.reviewStatus === '0' ? '' : this.reviewStatus
        }&uid=${this.getUId}&albumTitle=${query.albumTitle}&majorName=${
          query.majorName
        }&applyType=${query.applyType}&schoolId=${query.schoolId}&classCode=${
          query.classCode
        }&payStatus=${query.payStatus}&verifyStatus=${
          query.verifyStatus
        }&minPrice=${query.minPrice}&maxPrice=${query.maxPrice}&zName=${
          query.zName
        }&phone=${query.phone}&orderId=${query.orderId}&checkName=${
          query.checkName
        }&year=${query.year}&term=${query.term}&minCtime=${
          query.minCtime
        }&maxCtime=${query.maxCtime}`
      )
    },
    handleReviewStatusChange(tab) {
      this.pageObj.page = 1
      this.reviewStatus = tab.name
      this.getApplyList()
      if (tab.name !== '3') {
        if (this.isAddClass) {
          this.reviewStatusList.splice(3, 1)
          this.isAddClass = false
        }
      }
    },
    //搜索的折叠面板
    toggle() {
      if (this.activeNames.length > 0) {
        this.activeNames = []
        window.removeEventListener('keyup', this.enterQuery)
      } else {
        this.activeNames = ['1']
        window.addEventListener('keyup', this.enterQuery)
      }
    },
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },
    //清空搜索内容
    delAll() {
      this.form = { ...this.initForm }
      this.pageObj.page = 1
      this.getApplyList()
    },
    //搜索
    search() {
      // this.pageObj.page = 1
      this.getApplyList()
    },
    closeRegistInfo() {
      this.checkRegistInfo = false
    },

    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getApplyList()
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getApplyList()
    },
    visibleChange(e) {
      if (!e) {
        // this.$refs.applyTypeSelect.blur()
        // this.$refs.termListSelect.blur()
      }
    },

    // 查看报名信息
    checkRegistrationInfo(row) {
      console.log('row', row)
      this.operateParam = { status: 'info', ...row }
      this.checkRegistInfo = true
    },
    auditRegist(row) {
      console.log('row', row)
      this.operateParam = { status: 'edit', ...row }
      this.isShowClassRegistAudit = true
      console.log('isShowClassRegistAudit', this.isShowClassRegistAudit)
    },
    closeClassRegistAudit() {
      this.isShowClassRegistAudit = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
/deep/.el-collapse {
  padding-bottom: 20px;
}
.table_control {
  color: #409eff;
  .table_control_item {
    vertical-align: middle;
    cursor: pointer;
  }
}
/deep/.el-form-item__content {
  display: flex !important;
}
.BatchAuditDialog .el-col {
  font-size: 14px;
}
</style>